const VARIANTS = {
    success: { bg: '#dcfce7', color: '#15803d' },
    danger: { bg: '#fee2e2', color: '#b91c1c' },
    neutral: { bg: '#f1f5f9', color: '#475569' },
    info: { bg: '#e0f2fe', color: '#0369a1' },
    warning: { bg: '#fef3c7', color: '#b45309' },
    primary: { bg: 'var(--sp-primary-soft)', color: 'var(--sp-primary)' },
};

/**
 * Etiqueta de estado. Uso: <Badge variant="success">Sí</Badge>
 * Variantes: success | danger | neutral | info | warning | primary
 */
const Badge = ({ children, variant = 'neutral', icon: Icon }) => {
    const style = VARIANTS[variant] || VARIANTS.neutral;
    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.22rem 0.65rem',
                borderRadius: 999,
                fontSize: '0.75rem',
                fontWeight: 700,
                background: style.bg,
                color: style.color,
                whiteSpace: 'nowrap',
            }}
        >
            {Icon && <Icon size={12} />}
            {children}
        </span>
    );
};

export default Badge;